// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function decodeVehicle(param) {
  var id = Belt_Option.getExn(Js_json.decodeNumber(param[1])) | 0;
  return {
          id: id,
          name: param[0]
        };
}

function execute(json) {
  var vehicleObj = Belt_Option.getExn(Js_json.decodeObject(json));
  var vehicleDict = Belt_Option.getExn(Js_json.decodeObject(Belt_Option.getExn(Js_dict.get(vehicleObj, "vehicle"))));
  return $$Array.to_list($$Array.map(decodeVehicle, Js_dict.entries(vehicleDict)));
}

export {
  decodeVehicle ,
  execute ,
}
/* No side effect */
